import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin");
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.success) {
      navigate("/admin");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-void flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="mb-10 text-center">
          <a href="/" className="font-display text-2xl tracking-tight text-ink">
            Mixing Dreams <span className="text-coral">Ltd</span>
          </a>
          <p className="mt-2 text-xs uppercase tracking-[0.3em] text-smoke">Admin Panel</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="rounded-2xl border border-line bg-surface p-8"
          data-testid="admin-login-form"
        >
          <div className="mb-6 flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gold/10 text-gold">
              <Lock size={18} />
            </span>
            <h1 className="font-display text-2xl text-ink">Sign In</h1>
          </div>

          {error && (
            <div
              className="mb-5 rounded-lg border border-coral/40 bg-coral/10 px-4 py-3 text-sm text-coral"
              data-testid="login-error"
            >
              {error}
            </div>
          )}

          <div className="space-y-5">
            <div>
              <label className="mb-2 block text-xs uppercase tracking-widest text-smoke">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email-input"
                className="w-full rounded-lg border border-[#2a2a2a] bg-void px-4 py-3 text-ink outline-none transition-colors focus:border-gold"
              />
            </div>
            <div>
              <label className="mb-2 block text-xs uppercase tracking-widest text-smoke">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password-input"
                className="w-full rounded-lg border border-[#2a2a2a] bg-void px-4 py-3 text-ink outline-none transition-colors focus:border-gold"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-btn"
              className="w-full rounded-full bg-gold px-8 py-3.5 text-sm font-semibold uppercase tracking-widest text-black transition-all duration-300 hover:-translate-y-0.5 disabled:opacity-60"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </div>
        </form>

        <a
          href="/"
          className="mt-6 block text-center text-sm text-smoke hover:text-gold transition-colors"
        >
          &larr; Back to website
        </a>
      </div>
    </div>
  );
}
